export const kopeykaToRuble = (value: number) => value / 100
